<template>
  <div class="table-responsive">
    <div id="ta_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
      

      <div class="row" style="max-height: 22rem; overflow: auto;">
        <div class="col-sm-12">
          <table class="table table-hover display">
            <thead class="data-table-bg">
              <tr>
                <th v-for="(col, idx) in tableColumns" :key="idx" @click="sortBy(col[1])" style="cursor:pointer; text-align:left">
                  {{ col[0] }}
                  <span class="arrow" :class="sortOrders[col[1]] > 0 ? 'asc' : 'dsc'"></span>
                </th>
              </tr>
            </thead>
            <tbody v-if="dataTable && dataTable.length">
              <tr v-for="(row, i) in paginatedData" :key="i" :class="{ 'data-table-bg': i % 2 }">
                <td>{{ formatDate(row.timestamp) }}</td>
                <td>{{ row.alarmId }}</td>
                <td>{{ row.deviceName }}</td>
                <td>{{ row.imei }}</td>
                <td class="text-capitalize">{{ row.sensor }}</td>
                <td>{{ row.currentValue }}</td>
                <td>{{ row.expectedRange }}</td>
                <td>{{ row.user || '-' }}</td>
                <td>
                  <span class="status-dot" :class="row.status === 'critical' ? 'bg-danger' : 'bg-success'"></span>
                </td>
                <td>
                  <div class="d-flex align-items-center" style="gap:.6rem">
                    <span v-if="row.status === 'critical'" class="cursor-pointer" @click="$emit('edit', row)"><IconResolveNote /></span>
                    <span v-else class="cursor-pointer" @click="$emit('view', row)"><IconView /></span>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td :colspan="tableColumns.length" class="text-center py-4">{{ $t('no_data_found') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <PaginationNew
        :pageCount="pageCount"
        :data="paginatedData"
        :sizeperpage="sizeperpage"
        :pageNumber="pageNumber"
        :pages="pages"
        @goToLastPage="goToLastPage"
        @nextPage="nextPage"
        @handlePageChange="handlePageChange"
        @goToFirstPage="goToFirstPage"
        @prevPage="prevPage"
        @onchange="onchange"
      />
    </div>
  </div>
</template>

<script>
import tableMixin from '@/mixins/tableMixinWithBackend';
import PaginationNew from '@/components/PaginationNew.vue';
import IconResolveNote from '@/components/Iconsvg/IconResolveNote.vue';
import IconView from '@/components/Iconsvg/iconVisible.vue';

export default {
  name: 'TriggeredAlarmsTable',
  props: {
    stats: Array,
    paginationMeta: Object,
  },
  mixins: [tableMixin],
  components: { PaginationNew, IconResolveNote, IconView },
  data() {
    return {
      dataTable: [],
    };
  },
  created() {
    this.dataTable = this.stats || [];
  },
  watch: {
    stats: {
      handler(n) {
        this.dataTable = n || [];
      },
    },
  },
  computed: {
    tableColumns() {
      return [
        [this.$t('timestamp'), 'timestamp'],
        [this.$t('alarm_id'), 'alarmId'],
        [this.$t('device_name'), 'deviceName'],
        [this.$t('device_imei'), 'imei'],
        [this.$t('sensor'), 'sensor'],
        [this.$t('current_value'), 'currentValue'],
        [this.$t('expected_range'), 'expectedRange'],
        [this.$t('user'), 'user'],
        [this.$t('status'), 'status'],
        [this.$t('action'), ''],
      ];
    },
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      const pad = (n) => `${n}`.padStart(2, '0');
      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = `${d.getFullYear()}`.slice(-2);
      let hours = d.getHours();
      const minutes = pad(d.getMinutes());
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
      return `${day}/${month}/${year} ${pad(hours)}:${minutes}${ampm}`;
    },
  },
};
</script>

<style scoped>
.status-dot { width:10px; height:10px; border-radius:50%; display:inline-block; }
</style>

<i18n>
{
  "en": {
    "action": "",
    "timestamp": "Timestamp",
    "alarm_id": "Alarm ID",
    "device_name": "Device Name",
    "device_imei": "Device IMEI",
    "sensor": "Sensor",
    "current_value": "Current Value",
    "expected_range": "Expected Range",
    "user": "User",
    "status": "Status",
    "no_data_found": "No data found",
    "all_triggered_alarms": "All Triggered Alarms"
  },
  "fr": {
    "action": "",
    "timestamp": "Horodatage",
    "alarm_id": "ID d'alarme",
    "device_name": "Nom de l'appareil",
    "device_imei": "IMEI de l'appareil",
    "sensor": "Capteur",
    "current_value": "Valeur actuelle",
    "expected_range": "Plage attendue",
    "user": "Utilisateur",
    "status": "Statut",
    "no_data_found": "Aucune donnée trouvée",
    "all_triggered_alarms": "Toutes les alarmes déclenchées"
  }
}
</i18n>
